import { i18n } from '@/core/lib/i18n';
import type { LocalizedNames } from '@/interface/IFantasySelection';
import type { ITranslation } from '@/interface/ITranslation';
import { EnumLanguage } from '@/interface/enum';

export function getTranslated(translations: ITranslation[] | string | undefined | null, language?: EnumLanguage): string {
    try {
        if (!translations) {
            return '';
        }

        if (typeof translations === 'string') {
            return translations;
        }

        const lang = language ?? i18n.locale.value;
        const translation = translations.find(x => x.language === lang);
        if (translation) {
            return translation.value;
        }

        const englishTranslation = translations.find(x => x.language === EnumLanguage.EN);
        return englishTranslation?.value ?? '';
    } catch (error) {
        console.error('translations: ', translations, error);
        return '';
    }
}

export function getTranslatedName(names: LocalizedNames | string, language?: EnumLanguage): string {
    if (typeof names === 'string') {
        return names;
    }

    const lang = language ?? i18n.locale.value;
    return names[lang] ?? names.EN ?? '';
}
